import React from 'react';

import { Icon, layout } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdSettings,
  MdPeople,
  MdAdminPanelSettings,
  MdOutlineSupervisorAccount,
} from 'react-icons/md';
import { TbBellRinging, TbPasswordUser } from "react-icons/tb";
import { GrFormEdit } from "react-icons/gr";
import { FaBirthdayCake, FaLayerGroup, FaUserEdit, FaUsers, FaUserTie } from "react-icons/fa";
import { FaUserCheck, FaUserClock } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import { GiMedicines, GiProgression } from "react-icons/gi";
import { FaCodeBranch } from "react-icons/fa6";
import { MdHomeRepairService } from "react-icons/md";
import { MdMedicalServices } from "react-icons/md";
import { BiSolidPackage } from "react-icons/bi";
import { MdPerson3 } from "react-icons/md";
import { FaHandHoldingMedical } from "react-icons/fa6";
import { MdManageAccounts } from "react-icons/md";
import { CgDatabase, CgUserList } from "react-icons/cg";
import { IoMdDoneAll } from "react-icons/io";
import { AiOutlineMedicineBox, AiOutlineUserAdd } from "react-icons/ai";
import { GrUserAdmin } from "react-icons/gr";
import { GrTableAdd } from "react-icons/gr";
import { FaLaptopMedical } from "react-icons/fa";
import { BsFileMedical, BsTextareaResize } from "react-icons/bs";
import { LiaUserPlusSolid } from "react-icons/lia";
import { RiChatFollowUpLine } from "react-icons/ri";
import { LuUserCog, LuUserMinus, LuUserPlus2 } from "react-icons/lu";
import { LiaSortAmountUpSolid, LiaSortAmountDownAltSolid } from "react-icons/lia";
import { LuFileCheck, LuFileX } from "react-icons/lu";
import { VscNotebook } from "react-icons/vsc";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { LuFileText } from "react-icons/lu";
import { AiOutlineIssuesClose } from "react-icons/ai";
import { BiCommentCheck } from "react-icons/bi";
import { RiLockPasswordLine } from "react-icons/ri";
import { RiCoupon3Line } from "react-icons/ri";

// Admin Imports
import Profile from 'views/admin/profile';
import Lead from 'views/admin/lead';
import SignIn from 'views/auth/signIn';
import MasterDashboard from 'views/master/default'
import Doctor from 'views/master/doctor'
import Branch from 'views/master/branch';
import ChangePasswordRequest from 'views/master/ChnagePass/index';
import Councelor from 'views/master/counselor';
import DoctorDashboard from 'views/doctor/default'
import AdminUser from 'views/master/adminUser/Index';
import FileView from 'views/admin/viewLead/FileView';
import FollowUp from 'views/master/followup/FollowUp';
import { compose } from 'redux';
import AllFollowUp from 'views/master/followup/AllFollowUp';
import Setting from 'views/master/setting/Index';
import SuperAdminDashboard from './views/SuperAdmin/default'
import Admins from './views/SuperAdmin/admin'
import ActiveAdmins from './views/SuperAdmin/activeAdmin'
import ExpiredAdmins from './views/SuperAdmin/expiredAdmin'
import Plans from './views/SuperAdmin/plans';
import SuperAdminList from './views/SuperAdmin/superAdmins';
import ExtraAdminList from './views/admin/admins';
import FormFields from './views/admin/Formfilds/index';
import CreateModal from './views/admin/lead/CreateModal';
import Birthday from 'views/admin/birthday/birthday';
import { MdDashboard } from "react-icons/md"
import { FiUsers } from 'react-icons/fi';
import { HiOutlineDocumentSearch } from 'react-icons/hi';
import { IoBusinessSharp } from 'react-icons/io5';
import { PiUsersThreeBold, PiUsersThreeLight } from 'react-icons/pi';
const type = localStorage.getItem('type');


const isAuthenticated = localStorage.getItem('isAuthenticated')

let routes = []

if (!isAuthenticated) {
  routes.push(
    {
      name: 'Sign In',
      layout: '/auth',
      path: '/sign-in',
      icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
      component: <SignIn />,
    }
  );
}

if (type === 'Admin') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    // {
    //   name: 'Master',
    //   layout: '/master',
    //   path: '/masters',
    //   icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    //   component: <ExtraAdminList />,
    // },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdPeople width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        // {
        //   name: 'Add Lead',
        //   layout: '/master',
        //   icon: <AiOutlineUserAdd width="20px" height="20px" color="inherit" />,
        //   path: '/addLead',
        //   component: <CreateModal />,
        // },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <FiUsers width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: <TbBellRinging width="20px" height="20px" color="inherit" />,
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <GiProgression width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <HiOutlineDocumentSearch width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: <Icon as={FaBirthdayCake} width="20px" height="20px" color="inherit" />,
          path: '/birthdays',
          component: <Birthday />,
        }
      ]
    },
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />, // New Icon
      path: '/Consult',
      component: <Branch />,
      children: [
        {
          name: 'Branch',
          layout: '/master',
          path: '/branch',
          icon: <Icon as={IoBusinessSharp} width="20px" height="20px" color="inherit" />, // New Icon
          component: <Branch />,
        },
        {
          name: 'Form Fields',
          layout: '/master',
          path: '/formFields',
          icon: <Icon as={BsTextareaResize} width="20px" height="20px" color="inherit" />, // New Icon
          component: <FormFields />,
        },
        {
          name: 'Change Password',
          layout: '/master',
          path: '/changePassword',
          icon: <Icon as={TbPasswordUser} width="20px" height="20px" color="inherit" />, // New Icon
          component: <ChangePasswordRequest />,
        }
      ]
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: <Icon as={MdOutlineSupervisorAccount} width="20px" height="20px" color="inherit" />,
      path: '/adminUser',
      component: <AdminUser />,
      children: [
        {
          name: 'Admin User',
          layout: '/master',
          path: '/adminUser',
          icon: <FaUserTie width="20px" height="20px" color="inherit" />,
          component: <AdminUser />,
        },
        {
          name: 'Master',
          layout: '/master',
          path: '/masters',
          icon: <FaLayerGroup width="20px" height="20px" color="inherit" />,
          component: <ExtraAdminList />,
        },
      ],
    },
    // {
    //   name: 'Admin User',
    //   layout: '/master',
    //   icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
    //   path: '/adminUser',
    //   component: <AdminUser />,
    // },

    {
      name: 'Setting',
      layout: '/master',
      path: '/Setting',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      component: <Setting />,
    },
  )
};

if (type === 'Admin2') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },

    {
      name: 'CRM',
      layout: '/master',
      icon: <MdPeople width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        // {
        //   name: 'Add Lead',
        //   layout: '/master',
        //   icon: <AiOutlineUserAdd width="20px" height="20px" color="inherit" />,
        //   path: '/addLead',
        //   component: <CreateModal />,
        // },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <FiUsers width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: <TbBellRinging width="20px" height="20px" color="inherit" />,
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <GiProgression width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <HiOutlineDocumentSearch width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: <Icon as={FaBirthdayCake} width="20px" height="20px" color="inherit" />,
          path: '/birthdays',
          component: <Birthday />,
        }
      ]
    },
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      path: '/Consult',
      component: <Branch />,
      children: [
        {
          name: 'Branch',
          layout: '/master',
          path: '/branch',
          icon: <IoBusinessSharp width="20px" height="20px" color="inherit" />,
          component: <Branch />,
        },
        {
          name: 'Form Fields',
          layout: '/master',
          path: '/formFields',
          icon: <Icon as={BsTextareaResize} width="20px" height="20px" color="inherit" />,
          component: <FormFields />,
        },
      ]
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
      path: '/adminUser',
      component: <AdminUser />,
    },
    {
      name: 'Setting',
      layout: '/master',
      path: '/Setting',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      component: <Setting />,
    },
  )
};

if (type === 'Manager') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdPeople width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        // {
        //   name: 'Add Lead',
        //   layout: '/master',
        //   icon: <AiOutlineUserAdd width="20px" height="20px" color="inherit" />,
        //   path: '/addLead',
        //   component: <CreateModal />,
        // },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <FiUsers width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: <TbBellRinging width="20px" height="20px" color="inherit" />,
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <GiProgression width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <HiOutlineDocumentSearch width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: <Icon as={FaBirthdayCake} width="20px" height="20px" color="inherit" />,
          path: '/birthdays',
          component: <Birthday />,
        }
      ]
    },
  )
}

if (type === 'SuperAdmin') {

  routes.push(
    {
      name: 'Super Admin Dashboard',
      layout: '/superadmin',
      path: '/dashboard',
      icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
      component: <SuperAdminDashboard />,
    },
    {
      name: 'Admin User',
      layout: '/superadmin',
      icon: <Icon as={MdAdminPanelSettings} width="20px" height="20px" color="inherit" />, // Replaced FaUsers
      path: '/adminusers',
      component: <Admins />,
      children: [
        {
          name: 'Super Admin',
          layout: '/superadmin',
          path: '/superadmins',
          icon: <Icon as={LuUserCog} width="20px" height="20px" color="inherit" />, // Replaced GrUserAdmin
          component: <SuperAdminList />,
        },
        {
          name: 'All Admin Users',
          layout: '/superadmin',
          icon: <Icon as={PiUsersThreeBold} width="20px" height="20px" color="inherit" />, // Replaced FaUsers
          path: '/alladminusers',
          component: <Admins />,
        },
        {
          name: 'Active Admin Users',
          layout: '/superadmin',
          icon: <Icon as={FaUserEdit} width="20px" height="20px" color="inherit" />, // Replaced FaUserCheck
          path: '/activeadminusers',
          component: <ActiveAdmins />,
        },
        {
          name: 'Expired Admin Users',
          layout: '/superadmin',
          icon: <Icon as={LuUserMinus} width="20px" height="20px" color="inherit" />, // Replaced FaUserClock
          path: '/expiredadminusers',
          component: <ExpiredAdmins />,
        },
        {
          name: 'Plans',
          layout: '/superadmin',
          path: '/plans',
          icon: <Icon as={RiCoupon3Line} width="20px" height="20px" color="inherit" />,
          component: <Plans />,
        }
      ]
    },
  );
}

if (type === 'SuperAdmin2') {
  routes.push(
    {
      name: 'Super Admin Dashboard',
      layout: '/superadmin',
      path: '/dashboard',
      icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
      component: <SuperAdminDashboard />,
    },
    {
      name: 'Admin User',
      layout: '/superadmin',
      icon: <Icon as={PiUsersThreeLight} width="20px" height="20px" color="inherit" />,
      path: '/adminusers',
      component: <Admins />,
      children: [
        {
          name: 'All Admin Users',
          layout: '/superadmin',
          icon: <Icon as={CgUserList} width="20px" height="20px" color="inherit" />,
          path: '/alladminusers',
          component: <Admins />,
        },
        {
          name: 'Active Admin Users',
          layout: '/superadmin',
          icon: <Icon as={FaUserCheck} width="20px" height="20px" color="inherit" />,
          path: '/activeadminusers',
          component: <ActiveAdmins />,
        },
        {
          name: 'Expired Admin Users',
          layout: '/superadmin',
          icon: <Icon as={FaUserClock} width="20px" height="20px" color="inherit" />,
          path: '/expiredadminusers',
          component: <ExpiredAdmins />,
        }
      ]
    },
    {
      name: 'Plans',
      layout: '/superadmin',
      path: '/plans',
      icon: <Icon as={RiCoupon3Line} width="20px" height="20px" color="inherit" />,
      component: <Plans />,
    },
  );
}
export default routes;
